import {
  ADD_LOAN_REQUEST_REQUEST,
  ADD_LOAN_REQUEST_SUCCESS,
  ADD_LOAN_REQUEST_FAILURE,
  FETCH_LOAN_REQUESTS_REQUEST,
  FETCH_LOAN_REQUESTS_SUCCESS,
  FETCH_LOAN_REQUESTS_FAILURE,
  FETCH_LOAN_REQUEST_DETAILS_REQUEST,
  FETCH_LOAN_REQUEST_DETAILS_SUCCESS,
  FETCH_LOAN_REQUEST_DETAILS_FAILURE,
  UPDATE_LOAN_REQUEST_REQUEST,
  UPDATE_LOAN_REQUEST_SUCCESS,
  UPDATE_LOAN_REQUEST_FAILURE,
  DELETE_LOAN_REQUEST_REQUEST,
  DELETE_LOAN_REQUEST_SUCCESS,
  DELETE_LOAN_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  ADD_COMMENT_REQUEST_REQUEST,
  ADD_COMMENT_REQUEST_SUCCESS,
  ADD_COMMENT_REQUEST_FAILURE,
  SUBMIT_LOAN_REQUEST_REQUEST,
  SUBMIT_LOAN_REQUEST_SUCCESS,
  SUBMIT_LOAN_REQUEST_FAILURE,
  FETCH_LOAN_VOUCHERS_REQUEST,
  FETCH_LOAN_VOUCHERS_SUCCESS,
  FETCH_LOAN_VOUCHERS_FAILURE,
  CLEAR_LOAN_REQUESTS_ERROR,
} from "../actions/loanRequestActionTypes";

const initialState = {
  loanRequests: [],
  loanDetails: null,
  loanVouchers: null,
  isLoading: false,
  errors: {
    addLoanRequest: null,
    approve: null,
    attest: null,
    verify: null,
    reject: null,
    pay: null,
    query: null,
    fetchLoanRequests: null,
    fetchLoanRequestDetails: null,
    fetchLoanVouchers: null,
    updateLoanRequest: null,
    deleteLoanRequest: null,
    submit: null,
  },
};

const loanRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LOAN_REQUEST_REQUEST:
    case FETCH_LOAN_REQUESTS_REQUEST:
    case FETCH_LOAN_REQUEST_DETAILS_REQUEST:
    case UPDATE_LOAN_REQUEST_REQUEST:
    case DELETE_LOAN_REQUEST_REQUEST:
    case ADD_APPROVE_REQUEST_REQUEST:
    case ADD_ATTEST_REQUEST_REQUEST:
    case ADD_VERIFY_REQUEST_REQUEST:
    case ADD_REJECT_REQUEST_REQUEST:
    case ADD_PAY_REQUEST_REQUEST:
    case ADD_QUERY_REQUEST_REQUEST:
    case ADD_COMMENT_REQUEST_REQUEST:
    case SUBMIT_LOAN_REQUEST_REQUEST:
    case FETCH_LOAN_VOUCHERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          [action.type.replace("_REQUEST", "").toLowerCase()]: null,
        },
      };

    case ADD_LOAN_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanRequests: [
          ...state.loanRequests,
          { ...action.payload, id: action.payload.id || Date.now() },
        ],
        errors: { ...state.errors, addLoanRequest: null },
      };

    case FETCH_LOAN_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanRequests: action.payload,
        errors: { ...state.errors, fetchLoanRequests: null },
      };

    case FETCH_LOAN_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanDetails: action.payload,
        errors: { ...state.errors, fetchLoanRequestDetails: null },
      };

    case UPDATE_LOAN_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanRequests: state.loanRequests.map((request) =>
          request.id === action.payload.id ? action.payload : request,
        ),
        loanDetails:
          state.loanDetails?.id === action.payload.id
            ? action.payload
            : state.loanDetails,
        errors: { ...state.errors, updateLoanRequest: null },
      };

    case DELETE_LOAN_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanRequests: state.loanRequests.filter(
          (request) => request.id !== action.payload,
        ),
        errors: { ...state.errors, deleteLoanRequest: null },
      };

    case ADD_APPROVE_REQUEST_SUCCESS:
    case ADD_ATTEST_REQUEST_SUCCESS:
    case ADD_VERIFY_REQUEST_SUCCESS:
    case ADD_REJECT_REQUEST_SUCCESS:
    case ADD_PAY_REQUEST_SUCCESS:
    case ADD_QUERY_REQUEST_SUCCESS:
    case ADD_COMMENT_REQUEST_SUCCESS:
    case SUBMIT_LOAN_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanRequests: state.loanRequests.map((request) =>
          request.id === action.payload.id ? action.payload : request,
        ),
        loanDetails:
          state.loanDetails?.id === action.payload.id
            ? action.payload
            : state.loanDetails,
        errors: {
          ...state.errors,
          [action.type.replace("_SUCCESS", "").toLowerCase()]: null,
        },
      };

    case FETCH_LOAN_VOUCHERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loanVouchers: action.payload,
        errors: { ...state.errors, fetchLoanVouchers: null },
      };

    case ADD_LOAN_REQUEST_FAILURE:
    case FETCH_LOAN_REQUESTS_FAILURE:
    case FETCH_LOAN_REQUEST_DETAILS_FAILURE:
    case UPDATE_LOAN_REQUEST_FAILURE:
    case DELETE_LOAN_REQUEST_FAILURE:
    case ADD_APPROVE_REQUEST_FAILURE:
    case ADD_ATTEST_REQUEST_FAILURE:
    case ADD_VERIFY_REQUEST_FAILURE:
    case ADD_REJECT_REQUEST_FAILURE:
    case ADD_PAY_REQUEST_FAILURE:
    case ADD_QUERY_REQUEST_FAILURE:
    case ADD_COMMENT_REQUEST_FAILURE:
    case SUBMIT_LOAN_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          [action.type.replace("_FAILURE", "").toLowerCase()]:
            action.payload || "An error occurred.",
        },
      };

    case FETCH_LOAN_VOUCHERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        loanVouchers: null,
        errors: {
          ...state.errors,
          fetchLoanVouchers: action.payload || "Failed to fetch loan vouchers.",
        },
      };

    case CLEAR_LOAN_REQUESTS_ERROR:
      return {
        ...state,
        errors: initialState.errors,
      };

    default:
      return state;
  }
};

export default loanRequestReducer;
